module.exports = __webpack_public_path__ + "static/img/icon_visit_tab.2c2dcbe.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/hsbpc/views/welcome/components/img/icon_visit_tab.png
// module id = lZGD
// module chunks = 1